/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
import _debounce from 'lodash.debounce';
import { ComponentUtils } from '@/mixins';
import ShButton from '@/components/Helpers/ShButton';
import IconListToChooseFrom from '../Common/IconListToChooseFrom';
import LayoutForSingleConfigurationRow from '../Common/LayoutForSingleConfigurationRow';

import screensTemplates from './screens';


export default {
  name: 'WidgetScreensConfiguration',

  components: {
    ShButton,
    IconListToChooseFrom,
    LayoutForSingleConfigurationRow,
  },

  mixins: [ComponentUtils],

  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    widget: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      selectedScreen: 'modal_welcome',
      position: 0,
    };
  },

  computed: {
    screensTemplates() {
      const screensAccordingToAccessPermissions = this.$store.getters['authorization/accessPermissionsDefinitions'].screens;
      return Object.keys(screensTemplates).reduce((object, key) => {
        if (screensAccordingToAccessPermissions[key]) {
          // eslint-disable-next-line no-param-reassign
          object[key] = screensTemplates[key];
        }
        return object;
      }, {});
    },
    icons() {
      return this.$store.getters['settings/widgetIcons'].filter(icon => icon.page === this.selectedScreen);
    },
    possibleScreens() {
      return Object.keys(this.screensTemplates);
    },
    accessPermissionsDefinitions() {
      return this.$store.getters['authorization/accessPermissionsDefinitions'];
    },
  },

  created() {
    this.$store.dispatch('settings/getWidgetIcons');
    this.mMakeCopyFromProps('widget');
  },

  methods: {
    informAboutChangeOfTheSelectedScreen() {
      this.$EventBus.$emit('WidgetScreensConfiguration/SET_SELECTED_SCREEN', this.selectedScreen);
    },
    informAboutTheCurrentlyEditedElement(element) {
      this.$EventBus.$emit('WidgetScreensConfiguration/SET_FOCUS_TO_EDITED_ELEMENT', element);
    },
    iterateThroughScreens(direction) {
      this.position = this.possibleScreens.indexOf(this.selectedScreen);
      switch (direction) {
        case 'next':
          if (this.position < this.possibleScreens.length) this.position = this.position + 1;
          break;
        case 'previous':
          if (this.position > 0) this.position = this.position - 1; break;
        default: this.selectedScreen = 'modal_welcome';
      }
      this.selectedScreen = this.possibleScreens[this.position];
      this.informAboutChangeOfTheSelectedScreen();
    },
    handleSelectIcon(iconId, iconImage) {
      this.mCopy.widget.style[`${this.selectedScreen}_icon_id`] = iconId;
      this.mCopy.widget.page_icons[this.selectedScreen] = iconImage;
      this.updateWidget();
    },
    updateWidget: _debounce(function () {
      const newWidgetDetails = this.mCopy.widget;
      this.$store.dispatch('widgets/updateWidget', { newWidgetDetails });
    }, 300),
  },
};
